export default __webpack_public_path__ + "static/media/logo.2e13d0c2.png";